import React from "react";
import { Product } from "./index";

/* Props Type */
interface ListProps {
  products?: Product[];
  handleUpdate: (item: Product) => void;
  handleDelete: (id: string) => void;
}

/* Component */
const List: React.FC<ListProps> = ({
  products = [],
  handleUpdate,
  handleDelete,
}) => {
  return (
    <div className="product-list">
      {products.length === 0 ? (
        <div className="empty-state">
          No products found.
        </div>
      ) : (
        products.map((item) => (
          <div
            className="product-card"
            key={item._id}
          >
            {/* Image */}
            <img
              src={
                item.image
                  ? item.image
                  : "/placeholder.png"
              }
              alt={item.name}
              className="product-img"
            />

            {/* Info */}
            <div className="product-info">
              <h3>{item.name}</h3>

              <p className="price">
                ₹ {item.price}
              </p>
              <p className="desc">
                {item.description}
              </p>
              <p className="desc">
                Quantity: {item.quantity}
              </p>
              <p className="sub">
                {item.category?.name}
                {item.sub_category?.name && ` -> ${item.sub_category.name}`}
              </p>
              <p className="sub">
                MRP Price: ₹ {item.mrp_price}
              </p>
              <p className="sub">
                {item.bommenhali_price && `Bommenhali Price: ₹${item.bommenhali_price}  `}
              </p>
              <p className="sub">
                {item.kr_price && `KR Price: ₹${item.kr_price}`}
              </p>

              <p className="sub">
                {item.isSubcibed
                  ? "✅ Subscribed"
                  : "❌ Not Subscribed"}
              </p>

              {item.isSubcibed && (
                <p className="sub-qty">
                  Qty: {item.quantitySubcribed}
                </p>
              )}
            </div>

            {/* Actions */}
            <div className="product-actions">
              <button
                type="button"
                className="btn edit"
                onClick={() =>
                  handleUpdate(item)
                }
              >
                ✏️ Update
              </button>

              <button
                type="button"
                className="btn delete"
                onClick={() =>
                  handleDelete(item._id)
                }
              >
                🗑 Delete
              </button>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default List;
